/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoodsMarketBarcodeVo } from './GoodsMarketBarcodeVo';
import {
    GoodsMarketBarcodeVoFromJSON,
    GoodsMarketBarcodeVoFromJSONTyped,
    GoodsMarketBarcodeVoToJSON,
    GoodsMarketBarcodeVoToJSONTyped,
} from './GoodsMarketBarcodeVo';

/**
 * 
 * @export
 * @interface GoodsListForPackGoodsForPackVo
 */
export interface GoodsListForPackGoodsForPackVo {
    /**
     * 商品id
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    id?: number;
    /**
     * 商品编码
     * @type {string}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    code?: string;
    /**
     * 市场商品名称
     * @type {string}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    marketProNm?: string;
    /**
     * 当前商品记录的可包装数量；快递件商品为实际拆分后的独立数量
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    quantity?: number;
    /**
     * 装箱数量
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    packagedQuantity?: number;
    /**
     * 商品选项名称
     * @type {string}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    marketOptionName?: string;
    /**
     * 商品选项ID
     * @type {string}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    marketOptionId?: string;
    /**
     * 商品入库条码
     * @type {string}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    marketBarcode?: string;
    /**
     * 平台条码列表
     * @type {Array<GoodsMarketBarcodeVo>}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    marketBarcodes?: Array<GoodsMarketBarcodeVo>;
    /**
     * 商品重量 kg
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    weight?: number;
    /**
     * 商品长度
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    length?: number;
    /**
     * 商品宽度
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    width?: number;
    /**
     * 商品高度
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    height?: number;
    /**
     * 商品CBM
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    cbm?: number;
    /**
     * 是否从条码历史预填体积；预填仍需点击体积保存
     * @type {boolean}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    historyVolumePrefilled?: boolean;
    /**
     * 商品单独包装费用
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    individuallyPackagedFee?: number;
    /**
     * 商品合包包装费用
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    combinedPackagedFee?: number;
    /**
     * 贴条码费用
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    barcodeFee?: number;
    /**
     * 原产地标费用
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    originMarkFee?: number;
    /**
     * 使用opp袋费用
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    oppFee?: number;
    /**
     * 使用快递袋费用
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    courierBagFee?: number;
    /**
     * 商品是否可以原包装出库
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    originPackageOutbound?: number;
    /**
     * 商品来源
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    sourceType?: number;
    /**
     * sku id
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    skuId?: number;
    /**
     * sku编码
     * @type {string}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    skuCode?: string;
    /**
     * 原产地
     * @type {string}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    origin?: string;
    /**
     * 是否打印原产地 0 不打印，1 打印
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    originPrint?: number;
    /**
     * 是否为火箭订单拆出的快递件商品：0 否，1 是
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    simple?: number;
    /**
     * 商品图片URL
     * @type {string}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    imgUrl?: string;
    /**
     * 商品构成
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    constructQuantity?: number;
    /**
     * 商品名称
     * @type {string}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    name?: string;
    /**
     * 快递单号
     * @type {string}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    trackingNumber?: string;
    /**
     * 商品颜色
     * @type {string}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    color?: string;
    /**
     * 商品尺寸
     * @type {string}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    size?: string;
    /**
     * 原产地标作业方式，存客户下单编码或手填原文
     * @type {string}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    originJob?: string;
    /**
     * 原产地标作业方式展示名，按当前语言翻译枚举，手填原文原样返回
     * @type {string}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    originJobName?: string;
    /**
     * 是否合包商品 0 不是 1 是
     * @type {number}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    combined?: number;
    /**
     * 合包包装作业备注，仅合包商品有值
     * @type {string}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    combinedPackingRemark?: string;
    /**
     * 合包商品下的基础商品列表
     * @type {Array<GoodsListForPackGoodsForPackVo>}
     * @memberof GoodsListForPackGoodsForPackVo
     */
    baseGoodsForPackVOList?: Array<GoodsListForPackGoodsForPackVo>;
}

/**
 * Check if a given object implements the GoodsListForPackGoodsForPackVo interface.
 */
export function instanceOfGoodsListForPackGoodsForPackVo(value: object): value is GoodsListForPackGoodsForPackVo {
    return true;
}

export function GoodsListForPackGoodsForPackVoFromJSON(json: any): GoodsListForPackGoodsForPackVo {
    return GoodsListForPackGoodsForPackVoFromJSONTyped(json, false);
}

export function GoodsListForPackGoodsForPackVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoodsListForPackGoodsForPackVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'packagedQuantity': json['packagedQuantity'] == null ? undefined : json['packagedQuantity'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketBarcodes': json['marketBarcodes'] == null ? undefined : ((json['marketBarcodes'] as Array<any>).map(GoodsMarketBarcodeVoFromJSON)),
        'weight': json['weight'] == null ? undefined : json['weight'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'historyVolumePrefilled': json['historyVolumePrefilled'] == null ? undefined : json['historyVolumePrefilled'],
        'individuallyPackagedFee': json['individuallyPackagedFee'] == null ? undefined : json['individuallyPackagedFee'],
        'combinedPackagedFee': json['combinedPackagedFee'] == null ? undefined : json['combinedPackagedFee'],
        'barcodeFee': json['barcodeFee'] == null ? undefined : json['barcodeFee'],
        'originMarkFee': json['originMarkFee'] == null ? undefined : json['originMarkFee'],
        'oppFee': json['oppFee'] == null ? undefined : json['oppFee'],
        'courierBagFee': json['courierBagFee'] == null ? undefined : json['courierBagFee'],
        'originPackageOutbound': json['originPackageOutbound'] == null ? undefined : json['originPackageOutbound'],
        'sourceType': json['sourceType'] == null ? undefined : json['sourceType'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'origin': json['origin'] == null ? undefined : json['origin'],
        'originPrint': json['originPrint'] == null ? undefined : json['originPrint'],
        'simple': json['simple'] == null ? undefined : json['simple'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'constructQuantity': json['constructQuantity'] == null ? undefined : json['constructQuantity'],
        'name': json['name'] == null ? undefined : json['name'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'originJob': json['originJob'] == null ? undefined : json['originJob'],
        'originJobName': json['originJobName'] == null ? undefined : json['originJobName'],
        'combined': json['combined'] == null ? undefined : json['combined'],
        'combinedPackingRemark': json['combinedPackingRemark'] == null ? undefined : json['combinedPackingRemark'],
        'baseGoodsForPackVOList': json['baseGoodsForPackVOList'] == null ? undefined : ((json['baseGoodsForPackVOList'] as Array<any>).map(GoodsListForPackGoodsForPackVoFromJSON)),
    };
}

export function GoodsListForPackGoodsForPackVoToJSON(json: any): GoodsListForPackGoodsForPackVo {
    return GoodsListForPackGoodsForPackVoToJSONTyped(json, false);
}

export function GoodsListForPackGoodsForPackVoToJSONTyped(value?: GoodsListForPackGoodsForPackVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'marketProNm': value['marketProNm'],
        'quantity': value['quantity'],
        'packagedQuantity': value['packagedQuantity'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
        'marketBarcode': value['marketBarcode'],
        'marketBarcodes': value['marketBarcodes'] == null ? undefined : ((value['marketBarcodes'] as Array<any>).map(GoodsMarketBarcodeVoToJSON)),
        'weight': value['weight'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'cbm': value['cbm'],
        'historyVolumePrefilled': value['historyVolumePrefilled'],
        'individuallyPackagedFee': value['individuallyPackagedFee'],
        'combinedPackagedFee': value['combinedPackagedFee'],
        'barcodeFee': value['barcodeFee'],
        'originMarkFee': value['originMarkFee'],
        'oppFee': value['oppFee'],
        'courierBagFee': value['courierBagFee'],
        'originPackageOutbound': value['originPackageOutbound'],
        'sourceType': value['sourceType'],
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'origin': value['origin'],
        'originPrint': value['originPrint'],
        'simple': value['simple'],
        'imgUrl': value['imgUrl'],
        'constructQuantity': value['constructQuantity'],
        'name': value['name'],
        'trackingNumber': value['trackingNumber'],
        'color': value['color'],
        'size': value['size'],
        'originJob': value['originJob'],
        'originJobName': value['originJobName'],
        'combined': value['combined'],
        'combinedPackingRemark': value['combinedPackingRemark'],
        'baseGoodsForPackVOList': value['baseGoodsForPackVOList'] == null ? undefined : ((value['baseGoodsForPackVOList'] as Array<any>).map(GoodsListForPackGoodsForPackVoToJSON)),
    };
}

